// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__EziL-","item":"PaymentsMobile_item__3TjTQ","label":"PaymentsMobile_label__3RRzf","amount":"PaymentsMobile_amount__63Sz6"};